import { DefaultError } from 'errors/DefaultError';

export class EmailValidationError extends DefaultError {
  constructor() {
    const message = 'Invalid email address';

    super({
      name: EmailValidationError.name,
      message
    });
  }
  static get name() {
    return 'EmailValidationError';
  }
}
